export default __webpack_public_path__ + "static/media/pdfIcon.5a44d39f.svg";